import { defineStore } from 'pinia'
import { reactive, ref } from 'vue'
import { round } from 'mathjs'
import { required } from '@vuelidate/validators'
import { useRoute, useRouter } from 'vue-router'
import _ from "lodash"
export const useAuthenticatedUserCheckoutStore = defineStore('AuthenticatedUserCheckoutStore', {
    state: () => {
        return {
            tradelinesupplyPriceLink: 'https://tradelinesupply.com/pricing/',
            cartItems: [],
            total:0,
            checkoutIsActive: ref(0),
            cards: reactive({}),
            search: ref(''),
            minPrice: ref(0),
            maxPrice: ref(0),
            banks: reactive({}),
            selectedCards: reactive([]),
            range: reactive({
                min: 0,
                max: 0
            }),
            options : ref({
                0: 'New Order',
                1: 'Payment Successful',
                2: 'Payment Un-Successful',
                3: 'Order Fulfilled',
                4: 'Order Declined',
                5: 'Refund',
            }),
            creditCardNumber: ref(''),
            creditCard: reactive({
                number: ref(''),
                expiry: ref(''),
                cvc: ref('')
            }),
            billingDetail : reactive({
                firstName : ref(''),
                lastName : ref(''),
                address : ref(''),
                city : ref(''),
                state : ref(''),
                zipcode : ref(''),
                email : ref('')
            }),

            rules: reactive({
                creditCard:  {
                    number: {
                        required
                    },
                    expiry: {
                        required
                    },
                    cvc: {
                        required
                    }
                },
                billingDetail: {
                    firstName : {
                        required
                    },
                    lastName : {
                        required
                    },
                    address : {
                        required
                    },
                    city : {
                        required
                    },
                    state : {
                        required
                    },
                    zipcode: {
                        required
                    },
                    phoneNumber : {
                        required
                    },
                    email : {
                        required
                    }
                },
            }),
            isLoaded:ref(false),
            OrderOptions : [
                {id:0,name:'New Order'},
                {id:1,name:'Payment Successful'},
                {id:2,name:'Payment Un-Successful'},
                {id:3,name:'Order Fulfilled'},
                {id:4,name:'Order Declined'},
                {id:5,name:'Refund'}
            ],
            isActiveViewDetail:ref(0),
            user:reactive({}),
            isAcceptContract:ref(false),
            isDialogVisible:ref(false),
            isContractDialogVisible:ref(false),
            driverLicenseFile:ref(),
            socialSecurityFile:ref(),
            signature:ref(),
            isOrderDialogVisible:ref(false),
            AgreeToContract:ref(false)
        }
    },
    actions: {
        updatePrices() {
            let minCard = _.minBy(this.cards, function(card) { return round(card.price); });
            this.minPrice = minCard.price;
            let maxCard = _.maxBy(this.cards, function(card) { return round(card.price); });
            this.maxPrice = maxCard.price;
        },
        updateBanks() {
            let $this = this;
            this.banks = _.uniqBy(this.cards, 'bank_name');
            _.forEach(this.banks, function(bank) {
                bank.count = _.filter($this.cards, function(card) {
                    return card.bank_name.includes(bank.bank_name);
                }).length;
            });
        },
    },
    getters: {
    },
})
